import type { Confirmation } from '../domain/epharm';

export async function getConfirmation(code: string): Promise<Confirmation> {
  const response = await fetch(`${import.meta.env.VITE_EPHARM_API_BASE_URL}/confirmation`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${code}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch confirmation');
  }

  return (await response.json()) as Confirmation;
}

export async function deleteConfirmation(code: string): Promise<void> {
  const response = await fetch(`${import.meta.env.VITE_EPHARM_API_BASE_URL}/confirmation`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${code}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to delete confirmation');
  }
}
